// Branding directory — three tiers:
//   1. NATIONAL      — domestic (US-focused) branding/marketing/sonic-branding agencies
//   2. INTERNATIONAL — global-reach branding & artist-development partners
//   3. ANTHROPOLOGY  — primal-branding / brand-anthropology frameworks & studios
//
// Each entry: { name, website, address?, phone?, domain (for Clearbit logo) }
// When the website/domain is unverified, we fall back to Clearbit → Google favicon,
// or a Google search URL so the icon click still leads somewhere meaningful.

const search = (q) => `https://www.google.com/search?q=${encodeURIComponent(q)}`;

export const BRANDING_NATIONAL = [
  { name: "Bandzoogle", website: "https://bandzoogle.com", domain: "bandzoogle.com",
    address: "2045 W Grand Ave Ste B, PMB #92842, Chicago, IL 60612", phone: "(888) 966-4531" },
  { name: "C2 Management", website: "https://www.c2management.com", domain: "c2management.com",
    address: "230 1st Street, Berryville, VA 22611", phone: "(540) 955-5740" },
  { name: "AMW Group", website: "https://amworldgroup.com", domain: "amworldgroup.com",
    address: "100 Wilshire Blvd, Suite 700, Santa Monica, CA 90401", phone: "(310) 273-0220" },
  { name: "Musikvergnuegen", website: "https://www.musikvergnuegen.com", domain: "musikvergnuegen.com",
    address: "1118 Abbot Kinney Blvd, Venice, CA 90291", phone: "(323) 856-5900" },
  { name: "Made Music Studio", website: "https://www.mademusicstudio.com", domain: "mademusicstudio.com",
    address: "111 W 19th St, 5th Floor, New York, NY 10011", phone: "(212) 752-6233" },
  { name: "Sixième Son NYC", website: "https://www.sixiemeson.com", domain: "sixiemeson.com",
    address: "21 W. 46th Street, New York, NY 10036" },
  { name: "ICMP", website: "https://www.icmp.ac.uk", domain: "icmp.ac.uk" },
  { name: "Visual Branding", website: search("Visual Branding music agency") },
  { name: "BREEF", website: "https://www.breef.com", domain: "breef.com" },
  { name: "Modern Practice", website: search("Modern Practice branding agency") },
  { name: "CSG Music", website: search("CSG Music branding") },
  { name: "Studio Three Market", website: search("Studio Three Market branding") },
  { name: "Music Marketing", website: search("Music Marketing agency") },
  { name: "Maneuvers", website: search("Maneuvers music agency") },
  { name: "Apricity Agency", website: search("Apricity Agency music") },
  { name: "Blossom Agency", website: search("Blossom Agency music") },
  { name: "Downbeat", website: search("Downbeat music branding") },
  { name: "Spicy Tribe", website: search("Spicy Tribe music branding") },
  { name: "Duck Punk Productions", website: search("Duck Punk Productions music") },
  { name: "Clarity Music", website: search("Clarity Music agency") },
  { name: "On The Beat Music", website: search("On The Beat Music agency") },
  { name: "Real Music Lives", website: search("Real Music Lives agency") },
  { name: "Promote Music Agency", website: search("Promote Music Agency") },
  { name: "AB Media", website: search("AB Media music branding") },
  { name: "Creative Mind Firm", website: search("Creative Mind Firm music") },
  { name: "The Mora Mary Music Group", website: search("Mora Mary Music Group") },
  { name: "Ultimate Creative Sound Agency", website: search("Ultimate Creative Sound Agency") },
  { name: "Black Box", website: search("Black Box music branding") },
  { name: "Good Hands", website: search("Good Hands music branding") },
  { name: "Trent PR", website: search("Trent PR music") },
  { name: "Dotted Music", website: "https://dottedmusic.com", domain: "dottedmusic.com" },
  { name: "Sonic Branding", website: search("Sonic Branding agency") },
];

export const BRANDING_INTERNATIONAL = [
  { name: "Planetary Group", website: "https://www.planetarygroup.com", domain: "planetarygroup.com",
    address: "6161 Santa Monica Blvd, Ste 202, Los Angeles, CA 90038", phone: "(323) 952-5050" },
  { name: "5B Artist Management", website: "https://www.5bartistmgmt.com", domain: "5bartistmgmt.com",
    address: "1605 Pacific Ave, Venice, CA 90291", phone: "(310) 450-7132" },
  { name: "Sixième Son Paris", website: "https://www.sixiemeson.com", domain: "sixiemeson.com",
    address: "4, rue Scipion, 75005 Paris, France" },
  { name: "ICM Partners (CAA)", website: "https://www.caa.com", domain: "caa.com",
    address: "2000 Avenue of the Stars, Los Angeles, CA 90067", phone: "(424) 288-2000" },
  { name: "Global Trend", website: search("Global Trend music branding international") },
  { name: "Rising Music", website: search("Rising Music international agency") },
  { name: "The Replicas Music", website: search("The Replicas Music agency") },
  { name: "Artist Creating Entertainment", website: search("Artist Creating Entertainment") },
  { name: "I Mean It", website: search("I Mean It music branding") },
  { name: "AB Media International", website: search("AB Media international music") },
  { name: "Vox Pop Branding", website: search("Vox Pop Branding agency") },
  { name: "Rosmith Entertainment", website: search("Rosmith Entertainment") },
  { name: "Underground", website: search("Underground music branding agency") },
  { name: "Voodoo Guru", website: search("Voodoo Guru music branding") },
  { name: "TSMA", website: search("TSMA music branding agency") },
  { name: "Ignition Creative", website: "https://ignitioncreative.com", domain: "ignitioncreative.com" },
  { name: "IZMA Ent.", website: search("IZMA Entertainment music") },
  { name: "Trend PR", website: search("Trend PR music international") },
  { name: "View Maniac", website: search("View Maniac music branding") },
  { name: "CAA Music Branding Partnerships", website: "https://www.caa.com/capabilities/music-branding-partnerships", domain: "caa.com" },
];

export const BRANDING_ANTHROPOLOGY = [
  { name: "PrimalBranding (Patrick Hanlon)", website: "https://www.primalbranding.co", domain: "primalbranding.co",
    description: "The Patrick Hanlon framework — Creation Story, Creed, Icons, Rituals, Sacred Words, Non-Believers, Leader." },
  { name: "Fan Rituals", website: search("Patrick Hanlon Primal Branding fan rituals"),
    description: "Behavioural rituals that bond a fan community to a brand or artist." },
  { name: "Visual Mythology", website: search("brand visual mythology framework"),
    description: "Cohesive visual codes — logos, palettes, typography — that operate as tribal totems." },
  { name: "Shared Values & Ideology", website: search("brand shared values ideology framework"),
    description: "Codified beliefs that bind an audience around an artist or label." },
  { name: "Building Structural Sovereignty", website: search("brand structural sovereignty"),
    description: "Owning the IP, the channels, and the rituals — independence from third-party gatekeepers." },
  { name: "Profit Brand Strategy", website: search("Profit Brand Strategy book"),
    description: "Strategy framework converting brand anthropology into revenue and royalty streams." },
  { name: "RWS Global", website: "https://rwsglobal.com", domain: "rwsglobal.com",
    address: "153-157 Cleveland St, London W1T 6QR" },
  { name: "Tanj Branding", website: "https://www.tanjbrands.com", domain: "tanjbrands.com",
    address: "New York-based brand naming studio." },
  { name: "Ditto Music", website: "https://dittomusic.com", domain: "dittomusic.com",
    address: "11-15 St Mary's At Hill, London EC3R 8EE", phone: "+44 151 515 1515" },
];

export const BRANDING_TIERS = {
  national: {
    label: "National Branding",
    overline: "Domestic agencies · USA",
    intro:
      "Brand, marketing, sonic-branding, and artist-development agencies operating primarily within the United States — for composers, songwriters, and labels building a domestic brand presence.",
    entries: BRANDING_NATIONAL,
  },
  international: {
    label: "International Branding",
    overline: "Global reach · cross-border",
    intro:
      "Branding and artist-management partners with international reach — handling global album campaigns, multi-territory partnerships, and cross-border brand sync.",
    entries: BRANDING_INTERNATIONAL,
  },
  anthropology: {
    label: "Branding Anthropology",
    overline: "The Primal Code · framework studios",
    intro:
      "Frameworks and studios applying brand anthropology (Patrick Hanlon's PrimalBranding model — Creation Story, Creed, Icons, Rituals, Sacred Words, Non-Believers, Leader) to music careers, labels, and artist communities.",
    entries: BRANDING_ANTHROPOLOGY,
  },
};
